export default __webpack_public_path__ + "static/media/KZ.М.05.2165.a6542f8a.svg";